// extracted by mini-css-extract-plugin
module.exports = {"stats":"stats_stats__vSVP7","stats__item":"stats_stats__item__vYhiS"};